/* eslint-disable react-i18n/no-dynamic-translation-keys */
import React from "react";
import Reflux from "reflux";
import ReactTooltip from "react-tooltip";
import _ from "lodash";
import classNames from "classnames";
import { scaleLinear } from "d3";
import { auth } from "../../../../utils/firebaseUtils.js";
// Internal
import logger from "../../../../utils/LoggerFrontend.js";
import Actions from "../../../../Actions.js";
import CampaignCreateChannelView from "../../../SelfServiceCampaignCreation/Campaign__Create-ChannelView.jsx";
import CampaignCreatePlacementView from "../../../SelfServiceCampaignCreation/Campaign__Create-PlacementView.jsx";
import { CreateTipp } from "../../../SelfServiceCampaignCreation/campaign-create-tipp/CreateTipp.jsx";

import {
  getMinBudget,
  getMaxBudget,
  sortChannelsBasedOnJobCategoryRanking,
  updateChannelsWithBudget,
  getJobCategoryName,
  getL1JobCategory,
  calculateBudgetLevels,
  getCategoryMultiplier,
  formatIntlNumber
} from "../../../../utils/Helpers.js";

import { channels as ALL_CHANNELS } from "../../../../data/app__channels.js";

// Stores
import CampaignCreationStore from "../../../../Stores/CampaignCreationStore.js";
import { Store__System, CustomerSucessController } from "@talentbait/shared-components";

// Views
import { Heading } from "../../../../Components/Heading/index.js";
import {
  getDefaultBudget,
  isBudgetRecommendedOne,
  isChannelsRecommendedOnes
} from "../../../Campaign/Campaign__Budget-Calculator-utils.js";
import {
  CHANNEL_MULTIPLIER,
  MIN_BUDGET_FOUR_CHANNELS
} from "../../../../common/constants/pricing.js";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { BOOKING_STEPS } from "../../../SelfServiceCampaignCreation/campaign-creation/utils/constants.js";

// Import styled components
import {
  Budget,
  BudgetWarning,
  BudgetInput,
  BudgetMinMax
} from "./AssistantBudgetCalculator.styled.js";

// Import constants
import {
  TITLE,
  TITLE_BUDGET_CHECK,
  SUBTITLE,
  SUBTITLE_BUDGET_CHECK,
  FALLBACK_CAMPAIGN_COUNT,
  MIN_CAMPAIGN_CHANNELS,
  MAX_CAMPAIGN_CHANNELS
} from "./AssistantBudgetCalculator.constants";
import AdAssistantStore from "../../AdAssistantStore.js";
import { InvoiceAddressManager } from "../invoice-address/InvoiceAddressSelector.jsx";

//------------------------------------------------------------------------------
// Class
//------------------------------------------------------------------------------

let currentTime = 0;
class AssistantBudgetCalculator extends Reflux.Component {
  constructor(props) {
    super(props);

    // Initialize the views state with the props passed in
    this.state = {
      removedChannels: [],
      tempChannels: [],
      mappedLocations: [],

      // local States
      showAdditionalChannels: true,
      isLoadingEstimates: false,
      hasEnoughChannels: true,
      placements: [],
      budgetCheck: false,
      initiallyRecommendedChannels: [],
      isPredictionsLoading: true,
      hasSentSuccess: false,
      budgetSliderWidth: 0
    };

    this.stores = [Store__System, AdAssistantStore, CampaignCreationStore];
    logger.log("BudgetCalculator:constructor", "called..");

    this.campaignCreateUpdateBudgetDataWrapper =
      this.campaignCreateUpdateBudgetDataWrapper.bind(this);

    this.onChangeBudget = this.onChangeBudget.bind(this);

    this.handler = Actions.getReachEstimate.completed.listen(
      this.getReachEstimateHandler.bind(this)
    );
    this.handlerFailed = Actions.getReachEstimate.failed.listen(
      this.getReachEstimateHandlerFailed.bind(this)
    );
    this.createDebitoorCompanyFailed = Actions.createDebitoorCompany.failed.listen((err) => {
      logger.log("error:BudgetCalculator:createDebitoorCompany:failed", "called", {
        err
      });
      Actions.addNotification("Angebot konnte nicht erstellt werden", "error");
      Actions.toggleModal("showGenericModal", false);
    });

    this.createDebitoorCompanyHandler = Actions.createDebitoorCompany.completed.listen((result) => {
      const { userProfile } = this.state;
      logger.log("BudgetCalculator:createDebitoorCompany:completed", "called", {
        result,
        orgaId: userProfile.organizationId
      });
      const { id } = result && result.payload;

      if (id) {
        this.setState({
          selectedInvoiceAddress: result.payload
        });
        Actions.toggleModal("showGenericModal", false);

        this.createQuote();
      }
    });

    this.createQuoteHandlerCompleted = Actions.createQuote.completed.listen((quoteData) => {
      const { id } = quoteData && quoteData.payload;
      const { jobTitle, user, organization } = this.state;
      logger.debug("BudgetCalculator:renderDownloadBtn:createQuote", "quoteData...", { quoteData });
      if (id) {
        this.setState({
          quoteLabel: "Download offer (short version)"
        });

        Actions.notifiyEvent({
          eventName: "angebot",
          //channel: "#comments",
          text: `🔖 Angebot für die Stelle *${jobTitle}* runtergeladen von ${user.displayName} (${organization.name})`
        });

        auth.currentUser
          .getIdToken(true)
          .then(function (idToken) {
            window.open(`/api/v1/invoicing/quotes/${id}/pdf/?idToken=${idToken}`);
          })
          .catch((error) => {
            logger.debug(
              "BudgetCalculator:renderDownloadBtn:createQuote",
              "could not download quote",
              { error, id }
            );
          });
        return;
      }
      Actions.addNotification("Es ist ein Fehler aufgetreten, beim runterladen des PDFs.");
    });

    this.createQuoteHandlerFailed = Actions.createQuote.failed.listen((responseData) => {
      logger.debug("error:BudgetCalculator:renderDownloadBtn:createQuote", "responseData...", {
        responseData
      });
      this.setState({
        quoteLabel: "Download offer (short version)"
      });
      Actions.addNotification("Could not create quote", "error");
    });

    this.locationLookupCompletedRef = Actions.locationLookup.completed.listen((locationsResp) => {
      const locationCompletecurrentTime = Date.now();
      const diff = locationCompletecurrentTime - currentTime;
      logger.log("LocationLookup Completed", "time spent", { milliseconds: diff });

      if (
        this.state.campaignData &&
        this.state.organization &&
        Object.keys(this.state.organization).length > 0
      ) {
        this.generateRequestReachEstimate({ locationsResp, actionStatus: "completed" });
      }
    });

    this.locationLookupFailedRef = Actions.locationLookup.failed.listen((locationsResp) => {
      this.generateRequestReachEstimate({ locationsResp, actionStatus: "failed" });
    });

    this.invoiceAddressManager = new InvoiceAddressManager(this);

    this.updateBudgetSliderWidth = this.updateBudgetSliderWidth.bind(this);
  }

  componentWillUnmount() {
    logger.debug("BudgetCalculator:componentWillUnmount", "called..");
    this.handler();
    this.handlerFailed();

    this.createQuoteHandlerCompleted();
    this.createQuoteHandlerFailed();
    this.createDebitoorCompanyHandler();
    this.createDebitoorCompanyFailed();
    this.getPlacementHandler();
    this.locationLookupCompletedRef();
    this.locationLookupFailedRef();

    // Important:
    // Cancel the timer if present
    if (this.time) {
      clearTimeout(this.time);
    }

    window.removeEventListener("resize", this.updateBudgetSliderWidth);
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedInvoiceAddress, campaignData, organization, isPredictionsLoading } = this.state;

    // Check if any of the relevant values have changed
    const hasRelevantChanges =
      prevState.lifeTimeBudget !== this.state.lifeTimeBudget ||
      prevState.selectedChannels !== this.state.selectedChannels ||
      prevState.channels !== this.state.channels ||
      prevState.predictions !== this.state.predictions ||
      prevState.upsellChannels !== this.state.upsellChannels;

    if (hasRelevantChanges) {
      const newData = {
        lifeTimeBudget: this.state.lifeTimeBudget,
        selectedChannels: this.state.selectedChannels,
        channels: this.state.channels,
        predictions: this.state.predictions,
        upsellChannels: this.state.upsellChannels
      };

      this.props.setCampaignBudgetData(newData);
    }

    if (prevState.isPredictionsLoading && !isPredictionsLoading) {
      requestAnimationFrame(() => {
        this.updateBudgetSliderWidth();
      });
    }

    const refreshLookup =
      prevState.campaignData !== campaignData || prevState.organization !== organization;

    const prevBudgetCheck = new URLSearchParams(prevProps.location.search).get("budgetCheck");
    const budgetCheck = new URLSearchParams(this.props.location.search).get("budgetCheck");

    if (
      selectedInvoiceAddress?.id &&
      selectedInvoiceAddress?.id !== prevState.selectedInvoiceAddress?.id
    ) {
      this.setState({
        selectedInvoiceAddressData:
          selectedInvoiceAddress.addresses[selectedInvoiceAddress.addresses.length - 1] || {}
      });
    }

    if (prevBudgetCheck !== budgetCheck || refreshLookup) {
      logger.log("BudgetCalculator:location_keys", "location_keys", {
        test: JSON.parse(JSON.stringify(location))
      });

      const budgetcheck = new URLSearchParams(this.props.location.search).get("budgetCheck");

      if (budgetcheck == "true") {
        this.setState({ isPredictionsLoading: true });

        currentTime = Date.now();
        const hasLocations =
          campaignData && campaignData.locations && campaignData.locations.length > 0;
        if (organization && Object.keys(organization).length > 0 && hasLocations) {
          const { locations } = campaignData;
          Actions.locationLookup({ locations });
        }
      } else {
        this.setState({ isPredictionsLoading: false });
      }
    }
  }

  componentDidMount() {
    CustomerSucessController.send("BudgetCalculator:Channels_new:started");
    const {
      location,
      jobPostingUrl,
      jobTitle,
      userProfile,
      upsellChannels,
      selectedChannels,
      predictions,
      jobCategoryId,
      companyName,
      lifeTimeBudget: budget,
      organization
    } = this.state;

    const { userId, userName } = userProfile;
    const { id: orgaId, name: orgaName } = organization;

    logger.log("BudgetCalculator:componentDidMount", "called", {
      location,
      jobPostingUrl,
      jobTitle,
      userId,
      userName,
      orgaId,
      orgaName,
      upsellChannels,
      predictions,
      budget
    });

    logger.log("BudgetCalculator:location_keys", "location_keys", {
      test: JSON.parse(JSON.stringify(location))
    });

    const budgetCheck = new URLSearchParams(this.props.location.search).get("budgetCheck");
    const hasLocations = location && location.length > 0;

    if (budgetCheck == "true") {
      if (hasLocations) {
        this.setState({ isPredictionsLoading: true });
        Actions.locationLookup({ locations: location });
      }
    } else {
      this.setState({ isPredictionsLoading: false });
    }

    logger.debug("BudgetCalculator:componentDidMount", "passed in data...", organization);
    // Important:
    // Set the budget and channel for the first time

    this.campaignCreateUpdateBudgetDataWrapper({
      packageId: "newBooking",
      lifeTimeBudget: budget,
      selectedChannels: selectedChannels || ALL_CHANNELS,
      upsellChannels,
      predictions,
      jobCategoryId,
      source: "componentDidMount"
    });

    this.getPlacementHandler = Actions.getPlacements.completed.listen((fetchedPlacements) => {
      logger.log("BudgetCalculator:getPlacements", "completed", fetchedPlacements);
      this.setState({
        placements: fetchedPlacements.payload
      });
    });

    const refInvoiceAddresses = Actions.getCustomerAddresses.completed.listen((result) => {
      logger.log("BudgetCalculator:getCustomerAddresses", "fetched customer address", { result });

      const invoiceAddresses = result;
      const latestOption = invoiceAddresses[invoiceAddresses.length - 1];
      const defaultSelection =
        invoiceAddresses.find((address) => address.name === companyName) || latestOption; // select by companyName or the latest one

      this.setState({
        invoiceAddresses,
        selectedInvoiceAddress: defaultSelection,
        selectedInvoiceAddressData:
          defaultSelection?.addresses?.[defaultSelection?.addresses?.length - 1] || {}
      });
      refInvoiceAddresses();
    });

    const refFailedInvoiceAddresses = Actions.getCustomerAddresses.failed.listen((error) => {
      logger.log(
        "error:BudgetCalculator:getCustomerAddresses",
        "Unable to fetch customer address",
        {
          error,
          organization
        }
      );
      this.setState({
        invoiceAddresses: []
      });
      refFailedInvoiceAddresses();
    });

    //Actions.getCustomerAddresses(organization?.invoicesReceivers, false);

    // Add resize listener
    window.addEventListener("resize", this.updateBudgetSliderWidth);
    requestAnimationFrame(() => {
      this.updateBudgetSliderWidth();
    });
  }

  generateRequestReachEstimate({ locationsResp, actionStatus }) {
    const mappedLocations = locationsResp.payload;

    const {
      location,
      userProfile,
      lifeTimeBudget: budget,
      organization,
      campaignDuration = 30,
      campaignData
    } = this.state;

    const { jobPostLink, jobTitle } = campaignData;

    const location_keys = location.map((item) => item.fbLocId);
    const { userId, userName } = userProfile;
    const { id: orgaId, name: orgaName } = organization;

    const req = {
      link: jobPostLink,
      title: jobTitle,
      location: location_keys,
      facebook: "yes",
      instagram: "yes",
      budget,
      duration: campaignDuration,
      first_call: "yes",
      meta: {
        organization: {
          name: orgaName,
          id: orgaId
        },
        userName,
        userId,
        location: location[0] || []
      }
    };

    req.location = mappedLocations;

    const logMessage =
      actionStatus === "failed"
        ? "error:BudgetCalculator:locationLookup:failed"
        : "BudgetCalculator:locationLookup:completed";

    logger.log(logMessage, "called...", {
      locationsResp,
      mappedLocations,
      req
    });

    currentTime = Date.now();
    Actions.getReachEstimate(req);
    this.setState({ mappedLocations });
  }

  campaignCreateUpdateBudgetDataWrapper(data) {
    Actions.campaignCreateUpdateBudgetData({
      ...data,
      recommendedChannels: this.state.initiallyRecommendedChannels
    });
  }

  getReachEstimateHandlerFailed(response) {
    logger.log("error:BudgetCalculator:getReachEstimateHandlerFailed", "called..", {
      response
    });

    if (!response) {
      return logger.log("error:BudgetCalculator:getReachEstimateHandlerFailed", "called..");
    }

    const {
      predictions: previousPredictions,
      campaignDuration,
      jobCategoryId = "L1000_L2000_L3000",
      selectedChannels: previousSelectedChannels,
      upsellChannels: previousUpsellChannels,
      lifeTimeBudget: previousLifeTimeBudget
    } = this.state;

    const predictions = (response && response.payload) ||
      previousPredictions || {
        dataLoaded: true
      };
    const minBudget =
      (response.payload && response.payload.min_budget) || previousLifeTimeBudget || 700;

    const recommendationsBasedSortedChannels =
      predictions?.jobCategoryIdToChannelRankings && jobCategoryId != "L1000_L2000_L3000"
        ? sortChannelsBasedOnJobCategoryRanking(
            jobCategoryId,
            predictions.jobCategoryIdToChannelRankings
          )
        : ALL_CHANNELS;

    const selectedChannels =
      previousSelectedChannels ||
      updateChannelsWithBudget({
        budget: minBudget,
        channels: recommendationsBasedSortedChannels,
        jobCategoryId,
        campaignDuration
      });

    // Based on the list of selected channels, calucate the selected channels
    const upsellChannels =
      previousUpsellChannels ||
      _.differenceBy(ALL_CHANNELS, selectedChannels, "channel_short_name");

    logger.debug("BudgetCalculator:getReachEstimateHandlerFailed", "jobCategoryId..", {
      jobCategoryId
    });

    // Add timeout for a better effect in the UI
    this.time = setTimeout(() => {
      this.campaignCreateUpdateBudgetDataWrapper({
        packageId: "newBooking",
        lifeTimeBudget: minBudget,
        selectedChannels: selectedChannels,
        upsellChannels,
        predictions,
        jobCategoryId,
        source: "getReachEstimateHandlerFailed"
      });

      // It is very important to assign the initial recommended channels using a new array and passing the content
      // Otherwise the inmutability of the state make the initial recommended channels to be the same as the selected channels
      const newData = {
        predictions,
        budget: minBudget,
        isLoadingEstimates: false,
        selectedChannels,
        upsellChannels,
        jobCategoryId,
        initiallyRecommendedChannels: [...selectedChannels]
      };

      this.setState(newData);
      this.props.setCampaignBudgetData(newData);
    }, 500);

    this.setState({ isPredictionsLoading: false });
  }

  getReachEstimateHandler(response) {
    const {
      campaignDuration,
      jobTitle,
      userProfile,
      organization,
      companyName,
      location,
      jobPostingUrl
    } = this.state;

    const getReachEstimateHandlerCurrentTime = Date.now();
    const diff = getReachEstimateHandlerCurrentTime - currentTime;
    logger.log("GetReachEstimate Completed", "time spent", { milliseconds: diff });

    const jobCategoryIdResponse = response && response.payload && response.payload.jobCategoryId;

    logger.log("BudgetCalculator:getReachEstimateHandler", "called..", {
      response,
      campaignDuration,
      jobTitle,
      companyName,
      jobCategoryName: getJobCategoryName(
        response && response.payload && response.payload.jobCategoryId
      ),
      jobCategoryIdResponse
    });

    if (!response) {
      return logger.log("error:BudgetCalculator:getReachEstimateHandler", "error..", {
        jobPostingUrl,
        jobTitle,
        companyName,
        jobCategoryIdResponse
      });
    }

    const { payload } = response;
    const predictions = payload;

    let jobCategoryId = this.state.jobCategoryId || "L1000_L2000_L3000";
    const categoryMultiplier = getCategoryMultiplier(jobCategoryIdResponse);
    const multiplier = CHANNEL_MULTIPLIER * categoryMultiplier;

    const minimumBudget = getMinBudget(campaignDuration);

    const recommendedBudget = Math.ceil(parseInt(payload.min_budget, 10) * multiplier);
    const defaultBudget = Math.max(recommendedBudget, minimumBudget);

    logger.log("BudgetCalculator:getReachEstimateHandler", "next..", {
      response,
      campaignDuration,
      jobTitle,
      companyName,
      categoryMultiplier,
      jobCategoryName: getJobCategoryName(jobCategoryIdResponse),
      jobCategoryId: jobCategoryIdResponse,
      defaultBudget,
      minimumBudget,
      recommendedBudget,
      multiplier
    });

    const recommendationsBasedSortedChannels = sortChannelsBasedOnJobCategoryRanking(
      jobCategoryId,
      predictions.jobCategoryIdToChannelRankings
    );

    // Filters channels that can be shown as recommended
    const filteredRecommendationsBasedSortedChannels = recommendationsBasedSortedChannels.filter(
      (channel) => channel.isActive && channel.shouldShowInSelectedChannels
    );

    const selectedChannels = updateChannelsWithBudget({
      budget: defaultBudget,
      channels: filteredRecommendationsBasedSortedChannels,
      jobCategoryId: jobCategoryIdResponse,
      campaignDuration
    });

    // TODO: Fix these hard coded rules and move them to a recommender system

    // This is a special rule, as long as we didnt move the channel recommendation
    // to a centralized place

    // Based on the list of selected channels, calculate the selected channels
    const upsellChannels = _.differenceBy(
      recommendationsBasedSortedChannels,
      selectedChannels,
      "channel_short_name"
    );

    // Add timeout for a better effect in the UI
    logger.debug("BudgetCalculator:getReachEstimateHandler", "later..", {
      predictions,
      jobCategoryName: getJobCategoryName(jobCategoryIdResponse),
      jobCategoryId: jobCategoryIdResponse,
      jobTitle,
      companyName
    });

    // It is very important to assign the initial recommended channels using a new array and passing the content
    // Otherwise the inmutability of the state make the initial recommended channels to be the same as the selected channels
    this.setState({
      initiallyRecommendedChannels: [...selectedChannels]
    });

    const newBudgetData = {
      packageId: "newBooking",
      lifeTimeBudget: defaultBudget,
      selectedChannels,
      upsellChannels,
      predictions,
      jobCategoryId: jobCategoryIdResponse,
      source: "getReachEstimateHandler"
    };

    this.campaignCreateUpdateBudgetDataWrapper(newBudgetData);
    this.props.setCampaignBudgetData(newBudgetData);

    // Todo: Move to Segment and push to vitally

    const locationSize = predictions.city_size;
    const minClicks = this.props.calcMinClicks(defaultBudget || 0, selectedChannels);
    const locations = _.map(location, "location");
    const channels = _.map(selectedChannels, (channelData) =>
      _.capitalize(channelData.channel_short_name)
    );

    const baseUrlInternal = "https://internal.talentbait.de/admin";

    let icon = "";
    if (!organization.nrOfCampaigns || organization.nrOfCampaigns == 0) {
      // Its a new campaign
      icon = "⭐";
    }
    const hubspotLink = `https://app.hubspot.com/reports-dashboard/4391393/view/1531153?globalSearchQuery=${auth?.currentUser?.email}`;

    const slackText = `Budget Check ${icon} (${
      this.props.isBudgetCheck ? "Budget Check" : "Campaign Creation"
    }): ✅ Title: ${jobTitle} / <${`${baseUrlInternal}/users/${userProfile.userId}`}|👤${
      userProfile?.userName
    }> / 🏢 <${`${baseUrlInternal}/organizations/${organization?.id}`}|${
      organization?.name || companyName
    }> / <${hubspotLink}|Hubspot>/ 📍${locations.join(
      ", "
    )} / Reach: ${locationSize} / 💶 ${defaultBudget} € / MinClicks: ${minClicks} / Berufsgruppe: ${getJobCategoryName(
      jobCategoryIdResponse
    )} / Kanäle: ${channels.join(", ")}. /  (${campaignDuration} Tage) 
    ${jobPostingUrl}`;

    let slackChannel = "budget-checks";

    if (organization?.isAgency) {
      slackChannel = "budget-checks-agencies";
    }

    if (
      organization?.isTestAccount ||
      organization?.isTestAccount == "true" ||
      window.env !== "production"
    ) {
      slackChannel = "budget-checks-test";
    }

    if (!this.state.hasSentSuccess) {
      Actions.sendSlack(slackText, slackChannel, {});

      const data = {
        source: this.props.isBudgetCheck ? "Budget Check" : "Campaign Creation",
        userId: userProfile.userId,
        userName: userProfile.userName,
        organizationId: organization.id,
        organizationName: organization.name,
        jobTitle,
        jobPostingUrl,
        jobCategoryName: getJobCategoryName(jobCategoryIdResponse),
        jobCategoryId: jobCategoryIdResponse,
        locations,
        campaignDuration,
        defaultBudget,
        minClicks,
        selectedChannels: channels,
        companyName
      };

      CustomerSucessController.send("Budget Check created", data);

      Actions.saveBudgetCheck({
        ...data,
        channels,
        createdDate: new Date().toISOString(),
        orgaId: organization.id
      });

      this.setState({ hasSentSuccess: true });
    }
    // Todo: END Move to Segment and push to vitally

    Actions.getJobCategoryWithId(jobCategoryIdResponse);

    this.setState({ isPredictionsLoading: false });
  }

  // (1) TODO: Expose to helper function for onlyfy use
  onItemRemoved(name) {
    const {
      lifeTimeBudget: budget,
      upsellChannels,
      selectedChannels,
      removedChannels,
      predictions
    } = this.state;

    logger.debug("BudgetCalculator:onItemRemoved", "called...", {
      budget,
      upsellChannels,
      selectedChannels,
      removedChannels,
      predictions
    });

    if (selectedChannels.length === MIN_CAMPAIGN_CHANNELS) {
      logger.debug("BudgetCalculator:onItemRemoved", "selected channels one...", selectedChannels);

      this.setState({
        hasEnoughChannels: false
      });
      // NOTE: What is this setTimeout for?
      setTimeout(() => {
        this.setState({
          hasEnoughChannels: true
        });
      }, 2000);

      return;
    }

    var oldChannels = selectedChannels.slice();
    const index = _.findIndex(oldChannels, { channel_short_name: name });
    const channel = oldChannels[index];
    channel.isRemoved = true;

    const newSelectedChannels = _.differenceBy(oldChannels, [channel], "channel_short_name");
    const newUpsellChannels = upsellChannels;
    newUpsellChannels.push(channel);
    removedChannels.push(channel);

    logger.debug("BudgetCalculator:onItemRemoved", "name...", {
      name,
      selectedChannels: newSelectedChannels,
      upsellChannels: newUpsellChannels,
      removedChannels
    });

    // Set the state
    this.setState({
      removedChannels
    });

    // Tell the store
    this.campaignCreateUpdateBudgetDataWrapper({
      packageId: "newBooking",
      lifeTimeBudget: budget,
      selectedChannels: newSelectedChannels,
      upsellChannels: newUpsellChannels,
      predictions: predictions,
      source: "onItemRemoved"
    });
  }

  // (2) TODO: Expose to helper function for onlyfy use
  addBudget(name) {
    const {
      lifeTimeBudget: budget,
      upsellChannels,
      selectedChannels,
      budgetDifference,
      removedChannels,
      predictions
    } = this.state;

    logger.debug("BudgetCalculator:addBudget", "called...", {
      name
    });

    // Get the index of the passed in channel name
    const index = _.findIndex(upsellChannels, { channel_short_name: name });

    // Get the data of the selected channel
    const channel = upsellChannels[index];
    channel.isRemoved = false;

    // The list of channels without the one to be added
    const newUpsellChannels = _.differenceBy(upsellChannels, [channel], "channel_short_name");
    // The list of currently selected channels
    const newSelectedChannels = selectedChannels;
    // Add the new channel
    newSelectedChannels.push(channel);

    // Keep track if the removed channels
    var oldRemovedChannels = removedChannels;
    // Remove the channel from this list (TBH not sure how we use this list atm)
    const newRemovedChannels = _.differenceBy(oldRemovedChannels, [channel], "channel_short_name");

    var newBudget = budget + Math.abs(budgetDifference);

    this.setState({
      removedChannels: newRemovedChannels,
      channelToAddName: "",
      budgetDifference: 0,
      channelRequiresLongerDuration: false
    });

    this.campaignCreateUpdateBudgetDataWrapper({
      packageId: "newBooking",
      lifeTimeBudget: newBudget,
      selectedChannels: newSelectedChannels,
      upsellChannels: newUpsellChannels,
      predictions,
      source: "addBudget"
    });
  }
  // (3) TODO: Expose to helper function for onlyfy use
  calculateNeededBudget(newChannel) {
    const { lifeTimeBudget: budget, selectedChannels } = this.state;
    const newChannelPrice = newChannel.price;
    // How much min budget is currently in the selected package?
    const currentCartPrice = selectedChannels.reduce(
      (totalBudget, channel) => totalBudget + (parseFloat(channel.price) || 0),
      0
    );
    // The difference between the current budget and the min budget required for the current selected package
    const currentDifference = budget - currentCartPrice;

    logger.debug(
      "BudgetCalculator:calculateNeededBudget",
      "called:difference",
      currentDifference - newChannelPrice
    );

    //Is there enouph money for the new channel min budget?
    return currentDifference - newChannelPrice;
  }
  // (4) TODO: Expose to helper function for onlyfy use
  onChangeDuration() {
    return Actions.campaignCreateUpdateBudgetData({ currentStep: BOOKING_STEPS.STEP_BASE_DATA });
  }
  // (5) TODO: Expose to helper function for onlyfy use
  onItemAdded(name, addBudget = false) {
    const {
      upsellChannels,
      lifeTimeBudget: budget,
      selectedChannels,
      removedChannels,
      campaignDuration
    } = this.state;

    logger.debug("BudgetCalculator:onItemAdded", "called...", { name });
    const { t } = this.props;

    if (selectedChannels.length >= MAX_CAMPAIGN_CHANNELS) {
      logger.log("BudgetCalculator:onItemAdded", "Reach max number of channels", { name });
      Actions.addNotification(
        t("No more than {{MAX_CAMPAIGN_CHANNELS}} channels can be booked per campaign.", {
          MAX_CAMPAIGN_CHANNELS
        }),
        "error"
      );
      return;
    }

    const oldChannels = upsellChannels;

    // Find channel by name
    const index = _.findIndex(oldChannels, { channel_short_name: name });
    const channel = oldChannels[index];
    const newChannelPrice = channel.price;

    // How much min budget is currently in the selected package
    const currentCartPrice = selectedChannels.reduce(
      (totalBudget, channel) => totalBudget + (parseFloat(channel.price) || 0),
      0
    );

    // NOTE:
    // difference between the current budget and the min budget required for
    // the current selected package
    const currentDifference = budget - currentCartPrice;

    logger.debug("BudgetCalculator:calculateNeededBudget", "called:difference", {
      newPrice: currentDifference - newChannelPrice
    });

    const channelDifference = currentDifference - newChannelPrice;

    // Minimum budget required for max channels
    let fourCampaignsDifference = 0;
    if (selectedChannels.length === MAX_CAMPAIGN_CHANNELS - 1) {
      fourCampaignsDifference = Math.max(
        MIN_BUDGET_FOUR_CHANNELS - currentCartPrice - newChannelPrice,
        0
      );
    }

    const budgetDifference = Math.ceil(channelDifference - fourCampaignsDifference);
    const channelRequiresLongerDuration = campaignDuration < channel.minCampaignDuration;

    logger.debug("BudgetCalculator:onItemAdded", "called:difference", {
      budgetDifference,
      channelRequiresLongerDuration
    });

    // If the campaign duration is too small for the selected channel, then show a small message
    if (channelRequiresLongerDuration && !addBudget) {
      logger.log("BudgetCalculator:onItemAdded", "Campaign duration needs to be extended", {});
      this.setState({
        channelToAddName: name,
        channelRequiresLongerDuration
      });
      return;
    }

    // Missing budget to add the channel?
    // We show a small modal on the channel
    if (budgetDifference < 0 && !addBudget) {
      logger.debug("BudgetCalculator:onItemAdded", "Budget is too small", {
        budgetDifference
      });

      this.setState({
        channelToAddName: name,
        budgetDifference
      });
      return;
    }

    channel.isRemoved = false;

    const newUpsellChannels = _.differenceBy(oldChannels, [channel], "channel_short_name");

    const newSelectedChannels = selectedChannels;
    newSelectedChannels.push(channel);

    const oldRemovedChannels = removedChannels;
    const newRemovedChannels = _.differenceBy(oldRemovedChannels, [channel], "channel_short_name");

    this.campaignCreateUpdateBudgetDataWrapper({
      selectedChannels: newSelectedChannels,
      upsellChannels: newUpsellChannels,
      lifeTimeBudget:
        addBudget && budgetDifference < 0 ? budget + Math.abs(budgetDifference) : budget,
      source: "onItemAdded"
    });
    this.setState({
      removedChannels: newRemovedChannels,
      channelToAddName: "",
      budgetDifference: 0,
      channelRequiresLongerDuration: false
    });
  }

  onChangeJobCategory(jobCategoryId, newJobCategoryUpdates = {}) {
    const {
      lifeTimeBudget,
      jobTitle,
      predictions,
      jobPostingUrl,
      mappedLocations,
      campaignDuration,
      userProfile,
      organization,
      location
    } = this.state;

    logger.log("BudgetCalculator:onChangeJobCategory:jobCat", "called", {
      jobCategoryId
    });

    const recommendationsBasedSortedChannels = sortChannelsBasedOnJobCategoryRanking(
      jobCategoryId,
      predictions?.jobCategoryIdToChannelRankings
    );

    const selectedChannels = updateChannelsWithBudget({
      budget: lifeTimeBudget,
      jobCategoryId,
      campaignDuration,
      channels: recommendationsBasedSortedChannels
    });

    // Find the channels that are not in the selected channels
    const upsellChannels = _.differenceBy(
      recommendationsBasedSortedChannels,
      selectedChannels,
      "channel_short_name"
    );

    // Make query to the reach estimate calculator with the new job category
    const req = {
      link: jobPostingUrl,
      title: jobTitle,
      location: mappedLocations,
      facebook: "yes",
      instagram: "yes",
      budget: lifeTimeBudget,
      duration: campaignDuration,
      first_call: "yes",
      job_category_details: {
        ...(predictions?.job_category_details || {}), // Used for caching the job category details
        ...newJobCategoryUpdates
      },
      meta: {
        organization: {
          name: organization.name,
          id: organization.id
        },
        userName: userProfile.userName,
        userId: userProfile.userId,
        location: location || []
      }
    };
    logger.log(
      "BudgetCalculator:onChangeJobCategory:jobCat",
      "Start calling ML API to get new pricing for job category",
      {
        jobCategoryId,
        ...req
      }
    );

    Actions.getReachEstimate(req);

    logger.log("BudgetCalculator:onChangeJobCategory:jobCat", "Now set new Job category", {
      jobCategoryId
    });

    this.campaignCreateUpdateBudgetDataWrapper({
      jobCategoryId,
      selectedChannels,
      upsellChannels,
      source: "onChangeJobCategory"
    });

    this.setState({ removedChannels: [] });
  }
  // (6) TODO: Expose to helper function for onlyfy use
  onChangeBudget(e) {
    const {
      removedChannels,
      predictions,
      selectedChannels: currentSelection,
      campaignDuration,
      jobCategoryId
    } = this.state;

    const recommendationsBasedSortedChannels = sortChannelsBasedOnJobCategoryRanking(
      jobCategoryId,
      predictions?.jobCategoryIdToChannelRankings
    );

    const newBudget = parseInt(e.target.value, 10);

    const maxBudget = getMaxBudget(campaignDuration);
    if (newBudget > maxBudget) return;

    // Selected channels, without removed channels
    const diffChannels = _.differenceBy(
      recommendationsBasedSortedChannels,
      removedChannels,
      "channel_short_name"
    );

    const correctOrderChannels = _.unionBy(currentSelection, diffChannels, (item) => {
      return item.channel_short_name;
    });

    logger.debug("BudgetCalculator:onChangeBudget", "called", {
      newBudget,
      channels: recommendationsBasedSortedChannels.length,
      removedChannels,
      correctOrderChannels
    });

    const selectedChannels = updateChannelsWithBudget({
      budget: newBudget,
      channels: correctOrderChannels,
      campaignDuration
    });

    logger.debug("BudgetCalculator:onChangeBudget", "after rerecommending channels", {
      newBudget,
      channels: recommendationsBasedSortedChannels.length,
      selectedChannels
    });
    // Calculate the upsell channels
    const upsellChannels = _.differenceBy(
      _.uniqBy(
        recommendationsBasedSortedChannels.concat(removedChannels).reverse(),
        "channel_short_name"
      ).reverse(),
      selectedChannels,
      "channel_short_name"
    );

    // Save the changes
    this.campaignCreateUpdateBudgetDataWrapper({
      packageId: "newBooking",
      lifeTimeBudget: newBudget,
      selectedChannels: selectedChannels,
      upsellChannels,
      source: "onChangeBudget"
    });
  }
  abortEditPackage() {
    logger.debug("BudgetCalculator:abortEditPackage", "called");
    const { tempChannels } = this.state;

    this.setState({
      tempChannels: [],
      selectedChannels: _.cloneDeep(tempChannels),
      isEditing: false
    });
  }
  onClickedEditPakage(isEditing) {
    logger.debug("BudgetCalculator:onClickedEditPakage", "called");
    const { selectedChannels } = this.state;

    if (isEditing) {
      return this.setState({
        tempChannels: _.cloneDeep(selectedChannels),
        isEditing: isEditing
      });
    }

    Actions.addNotification("Änderungen wurden übernommen.");

    this.setState({
      isEditing: isEditing
    });
  }
  getReachDescriptionLabel(min_budget, budget_500, budget_1000, budget_1500) {
    const { t } = this.props;
    var reichweiteDescription = "Budget";
    const { lifeTimeBudget: budget } = this.state;
    const newBudget = budget;
    if (newBudget == min_budget) {
      reichweiteDescription = t("Recommended minimum budget");
    } else if (newBudget > min_budget && newBudget < budget_500) {
      reichweiteDescription = t("Good range");
    } else if (newBudget >= budget_500 && newBudget < budget_1000) {
      reichweiteDescription = t("Strong range");
    } else if (newBudget >= budget_1000 && newBudget < budget_1500) {
      reichweiteDescription = t("Very strong range");
    } else if (newBudget >= budget_1500) {
      reichweiteDescription = t("Maximum range");
    } else if (budget < min_budget) {
      reichweiteDescription = t("Small range");
    }
    return reichweiteDescription;
  }

  jumpToBudget(budget) {
    const {
      removedChannels,
      selectedChannels: currentSelection,
      jobTitle,
      predictions: { jobCategoryIdToChannelRankings },
      jobCategoryId,
      campaignDuration
    } = this.state;
    const newBudget = parseInt(budget, 10);
    const recommendationsBasedSortedChannels = sortChannelsBasedOnJobCategoryRanking(
      jobCategoryId,
      jobCategoryIdToChannelRankings
    );
    logger.debug("BudgetCalculator:jumpToBudget", "called", {
      newBudget,
      recommendationsBasedSortedChannels
    });

    const diffChannels = _.differenceBy(
      recommendationsBasedSortedChannels,
      removedChannels,
      "channel_short_name"
    );

    const correctOrderChannels = _.unionBy(currentSelection, diffChannels, (item) => {
      return item.channel_short_name;
    });

    const selectedChannels = updateChannelsWithBudget({
      jobTitle,
      budget: newBudget,
      channels: correctOrderChannels,
      campaignDuration
    });
    const upsellChannels = _.differenceBy(
      _.uniqBy(
        recommendationsBasedSortedChannels.concat(removedChannels).reverse(),
        "channel_short_name"
      ).reverse(),
      selectedChannels,
      "channel_short_name"
    );

    this.setState({
      budget: newBudget,
      selectedChannels,
      upsellChannels
    });
  }
  renderSingleTick(budget, scale) {
    const valPercentage = scale(budget);

    return (
      <div
        onClick={this.jumpToBudget.bind(this, budget)}
        className="tickmark__lowest"
        style={{ left: `${Number.parseFloat(valPercentage).toFixed(1)}%` }}
      >
        {" "}
      </div>
    );
  }
  renderTicks(maxBudget, minBudget, budget_default, budget_500, budget_1000, budget_1500) {
    const scaleMapping = scaleLinear()
      .domain([minBudget, maxBudget])
      .range([2.9, 100 - 2.9]);

    logger.debug("BudgetCalculator:renderTicks", "called", {
      maxBudget,
      minBudget,
      budget_500,
      budget_1000,
      budget_1500,
      scaleMapping,
      budget_default
    });

    return (
      <div style={{ position: "relative", width: "100%" }}>
        {this.renderSingleTick(budget_500, scaleMapping)}
        {this.renderSingleTick(budget_1000, scaleMapping)}
        {this.renderSingleTick(Math.min(budget_1500, maxBudget), scaleMapping)}
      </div>
    );
  }
  renderHeaderArea() {
    const { isBudgetCheck, t } = this.props;
    return (
      <div className="create__campaign-heading">
        <Heading
          title={isBudgetCheck ? t(TITLE_BUDGET_CHECK) : t(TITLE)}
          subtitle={isBudgetCheck ? t(SUBTITLE_BUDGET_CHECK) : t(SUBTITLE)}
        />
        {
          <div className="create__company-step">
            {t("Step")} 2 / {isBudgetCheck ? "2" : "4"}
          </div>
        }
      </div>
    );
  }
  renderLoadingState() {
    const { t } = this.props;

    const mainAreaStyle = classNames({
      "campaign_create__sticky white": true
    });

    return (
      <div style={{ width: "100%" }}>
        <div className="App center fade-in">
          {this.renderHeaderArea()}

          <div className={mainAreaStyle}>
            <center
              className="blinking"
              style={{
                fontSize: "20px",
                width: "100%",
                opacity: 0.5,
                height: "500px",
                lineHeight: "500px"
              }}
            >
              {t("Calculating the perfect budget for this position…")}
            </center>
          </div>
        </div>
      </div>
    );
  }

  extraLocCost() {
    const { extraBudgetLocations } = this.state;
    const length = extraBudgetLocations.length;

    let locationsCost = 0;
    for (let i = 0; i < length; i++) {
      locationsCost += extraBudgetLocations[i].price;
    }

    return locationsCost;
  }

  renderAdditionalLocCost() {
    const { extraBudgetLocations } = this.state;
    const length = extraBudgetLocations.length;
    const standort = length === 1 ? "Standort" : "Standorte";

    if (length > 0) {
      return (
        <div style={{ color: "green", marginTop: "-10px", paddingBottom: "5px" }}>
          + {length} Extra {standort} {this.extraLocCost()}€
        </div>
      );
    }
  }

  setSelectedInvoiceAddressData(value) {
    this.setState({
      selectedInvoiceAddressData: value
    });
  }

  onSelectAddress(selected) {
    if (!selected) {
      this.invoiceAddressManager.openAddressModal();
    } else {
      const selectedInvoiceAddress = selected;
      let selectedInvoiceAddressData = {};
      if (selectedInvoiceAddress?.addresses?.length) {
        selectedInvoiceAddressData =
          selectedInvoiceAddress.addresses[selectedInvoiceAddress.addresses.length - 1] || {};
      }

      this.setState({
        selectedInvoiceAddress,
        selectedInvoiceAddressData
      });
      Actions.campaignCreateUpdateReviewData({ currentlySelectedAddress: selectedInvoiceAddress });
    }
  }

  createQuote() {
    const {
      lifeTimeBudget: budget,
      selectedChannels = [],
      jobTitle,
      organization,
      campaignDuration,
      location,
      userProfile,
      companyName,
      selectedInvoiceAddress,
      selectedInvoiceAddressData
    } = this.state;

    const { campaignData } = this.state;

    this.setState({
      quoteLabel: "..."
    });

    const hasStateLocations = location && location.length > 0;
    const finalLocations = hasStateLocations ? location : campaignData.locations;

    Actions.createQuote({
      customerId: selectedInvoiceAddress.id,
      lifeTimeBudget: budget + this.extraLocCost(),
      selectedChannels: selectedChannels,
      jobTitle: jobTitle,
      locations: finalLocations,
      campaignDuration,
      address: selectedInvoiceAddressData.street || "",
      countryCode: selectedInvoiceAddressData.countryCode || "",
      customerName: companyName
    });

    const { name: orgaName, id: orgaId } = organization;

    const { userName, userId } = userProfile;

    const slackText = `🔋 Angebot heruntergeladen! Job Title: ${jobTitle} / ${companyName} (<https://internal.talentbait.de/admin/organizations/${orgaId}|${orgaName}>) / ${budget}€ / ${campaignDuration} Tage / ${location
      .map((loc) => loc.location || "")
      .join(", ")} / Kanäle: ${selectedChannels
      .map((channel) => channel.channel_short_name)
      .join(", ")} / userName: <https://internal.talentbait.de/admin/users/${userId}|${userName}>`;

    Actions.sendSlack(slackText, "#comments-angebot", {});
  }

  renderDownloadBtn() {
    const { selectedChannels = [], quoteLabel } = this.state;
    const { t } = this.props;

    if (!selectedChannels?.length) {
      return;
    }

    return (
      <div
        className="link"
        style={{ marginBottom: 10 }}
        onClick={() => this.invoiceAddressManager.startDownloadFlow()}
      >
        {t(quoteLabel || "Download offer (short version)")}
      </div>
    );
  }

  // Update the method to measure width more reliably
  updateBudgetSliderWidth() {
    const budgetSlider = document.getElementById("budget-slider");
    if (budgetSlider) {
      const width = budgetSlider.getBoundingClientRect().width;
      if (width > 0) {
        this.setState({
          budgetSliderWidth: width
        });
      }
    }
  }

  render() {
    const {
      isLoadingEstimates,
      predictions = {},
      isPredictionsLoading,
      isEditing,
      upsellChannels,
      selectedChannels,
      hasEnoughChannels,
      showAdditionalChannels,
      channelToAddName,
      budgetDifference,
      lifeTimeBudget: budget,
      placements,
      jobCategoryId,
      packageId,
      userProfile,
      campaignDuration,
      location,
      campaignData,
      organization,
      budgetSliderWidth
    } = this.state;

    const { t } = this.props;

    const { userName, userId } = userProfile;

    logger.debug("BudgetCalculator:render", "called...", {
      isLoadingEstimates,
      predictions,
      isEditing,
      upsellChannels,
      selectedChannels,
      hasEnoughChannels,
      showAdditionalChannels,
      channelToAddName,
      budgetDifference,
      budget,
      placements,
      jobCategoryId,
      packageId,
      userName,
      userId,
      location,
      campaignData,
      isPredictionsLoading,
      organization,
      state: this.state
    });

    if (isLoadingEstimates) {
      return this.renderLoadingState();
    }

    if (isPredictionsLoading) {
      return this.renderLoadingState();
    }

    const {
      city_size = "medium",
      budget_500 = 500,
      budget_1000 = 1000,
      budget_1500 = 1500,
      jobCategoryIdToChannelRankings = []
    } = predictions;

    // Add the price multiplier to the budgets
    const { budget500, budget1000, budget1500 } = calculateBudgetLevels({
      budget_500,
      budget_1000,
      budget_1500,
      jobCategoryId
    });

    const maxBudget = getMaxBudget(campaignDuration);
    const minBudget = getMinBudget(campaignDuration);

    // We create 4 different type of budget recommendations for the user
    // for orientation based on what he is willing to pay.
    const budgetDefault = getDefaultBudget({ jobCategoryId, minBudget });

    const reichweiteDescription = this.getReachDescriptionLabel(
      budgetDefault,
      budget500,
      budget1000,
      budget1500
    );

    const editStyle = classNames({
      "channel__item-wrapper": true,
      editing: isEditing === true
    });

    const mainAreaStyle = classNames({
      "campaign_create__sticky white": true,
      "campaign_create__sticky--loading": isLoadingEstimates
    });

    const l1JobCategoryId = getL1JobCategory(jobCategoryId);
    const jobCategoryName = getJobCategoryName(l1JobCategoryId);
    const campaignCount =
      _.find(jobCategoryIdToChannelRankings, {
        id: l1JobCategoryId
      })?.campaignCount || FALLBACK_CAMPAIGN_COUNT;

    const filteredActiveSelectedChannels = selectedChannels.filter((selectedChannel) => {
      const matchingChannel = ALL_CHANNELS.find(
        (channel) => channel.channel_short_name === selectedChannel.channel_short_name
      );

      return matchingChannel && matchingChannel.isActive;
    });

    return (
      <div style={{ width: "100%" }}>
        <div className="App center fade-in">
          {this.renderHeaderArea()}

          <div className={mainAreaStyle} style={{ marginBottom: "80px" }}>
            <div className="campaign_create__input">
              <div className={editStyle}>
                <div className="tags" style={{ position: "static" }}>
                  {!isEditing && <div className="tag">{t("Selected package")}</div>}

                  {isEditing && (
                    <div className="tag edit">{t("You are currently editing this package")}</div>
                  )}

                  {isBudgetRecommendedOne({ budget, budget_default: budgetDefault }) &&
                    !isEditing &&
                    isChannelsRecommendedOnes({
                      recommendedChannels: this.state.initiallyRecommendedChannels,
                      selectedChannels: this.state.selectedChannels
                    }) && (
                      <div className="tag special fade-in">
                        <span>{t("Our recommendation")}</span>
                        <img
                          src="/images/info.svg"
                          data-tip={t(
                            "Data-driven channel recommendation based on {{campaignCount}} successful campaigns in the category: {{jobCategoryName}}",
                            {
                              campaignCount,
                              jobCategoryName
                            }
                          )}
                          className="tipp_info__tool-icon"
                          alt="Recommendations"
                        />
                      </div>
                    )}
                </div>
                {filteredActiveSelectedChannels.map((channel) => {
                  return (
                    <div key={channel.channel_short_name}>
                      <CampaignCreateChannelView
                        key={channel.channel_short_name}
                        name={channel.channel_short_name}
                        fullname={channel.channel_full_name}
                        description={t(channel.description)}
                        onShowPreview={this.props.onShowPreview.bind(
                          this,
                          channel.channel_short_name
                        )}
                        isEditing={isEditing}
                        onItemRemoved={this.onItemRemoved.bind(this, channel.channel_short_name)}
                        canRemove={!hasEnoughChannels}
                      />
                      {channel.channel_short_name == "google-display" &&
                        placements.map((placement) => {
                          return (
                            <div key={placement.name}>
                              <CampaignCreatePlacementView
                                key={placement.name}
                                name={placement.name}
                                url={placement.url}
                              />
                            </div>
                          );
                        })}
                    </div>
                  );
                })}
              </div>
              <div className="channels__edit_bar">
                {!isEditing && (
                  <div className="edit" onClick={this.onClickedEditPakage.bind(this, true)}>
                    {t("Customize package")}
                  </div>
                )}
                {isEditing && (
                  <div className="edit" onClick={this.abortEditPackage.bind(this, false)}>
                    {t("cancel")}
                  </div>
                )}
                {isEditing && (
                  <div className="edit" onClick={this.onClickedEditPakage.bind(this, false)}>
                    {t("done")}
                  </div>
                )}
              </div>
              <br />
              <br />
              <br />
              {!showAdditionalChannels && <div className="line_divider"></div>}
              <br />
              {showAdditionalChannels && (
                <div className="description">
                  <h4
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      this.setState({
                        showAdditionalChannels: false
                      });
                    }}
                  >
                    {t("Additional bookable channels")}
                  </h4>
                  <p> {t("The target group can be reached via these other channels:")}</p>
                </div>
              )}
              {!showAdditionalChannels && (
                <div className="description">
                  <h4
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      this.setState({
                        showAdditionalChannels: true
                      });
                    }}
                  >
                    {t("Show additional bookable channels")}
                  </h4>
                </div>
              )}
              {showAdditionalChannels &&
                upsellChannels
                  .filter((c) => c.isActive)
                  .map((channel) => {
                    const shortName = channel.channel_short_name;
                    return (
                      <CampaignCreateChannelView
                        key={shortName}
                        name={shortName}
                        fullname={channel.channel_full_name}
                        description={t(channel.description)}
                        minCampaignDuration={channel.minCampaignDuration}
                        // isChecked={channel.switchedOn}
                        onShowPreview={this.props.onShowPreview.bind(this, shortName)}
                        isActive={true}
                        onItemAdded={this.onItemAdded.bind(this, shortName)}
                        addBudget={this.addBudget.bind(this, shortName)}
                        onChangeDuration={this.onChangeDuration.bind(this)}
                        budgetDifference={channelToAddName == shortName ? budgetDifference : 0}
                        channelRequiresLongerDuration={
                          channelToAddName == shortName &&
                          channel.minCampaignDuration > campaignDuration
                        }
                      />
                    );
                  })}{" "}
            </div>
            <div className="campaign_create__stats" style={{ top: "20px" }}>
              <div className="wrapper">
                <img src="/images/cash.png" />

                <div className="right">
                  <Budget className="animated 5s flash">
                    <BudgetInput
                      placeholderIsMinWidth
                      extraWidth={0}
                      minWidth={1}
                      type="number"
                      step={1}
                      value={budget}
                      placeholder="0"
                      min={minBudget}
                      max={maxBudget}
                      onChange={this.onChangeBudget}
                    />
                    <span>€</span>
                    <img
                      src="/images/info.svg"
                      data-tip={t(
                        "The budget used for the campaign. Initially distributed equally across all channels and later optimized according to performance."
                      )}
                      className="tipp_info__tool-icon"
                    />
                    <BudgetMinMax>
                      <p>{`Min: ${formatIntlNumber(minBudget, {
                        language: userProfile?.language
                      })} €`}</p>
                      <p>{`Max: ${formatIntlNumber(maxBudget, {
                        language: userProfile?.language
                      })} €`}</p>
                    </BudgetMinMax>
                    {(!budget || budget < minBudget) && (
                      <BudgetWarning>{`Minimum Budget: ${formatIntlNumber(minBudget, {
                        language: userProfile?.language
                      })} €`}</BudgetWarning>
                    )}
                  </Budget>
                  <p>{t("Recommended budget for this campaign")}</p>
                  {this.renderAdditionalLocCost()}
                  {this.renderDownloadBtn()}
                </div>
              </div>

              <input
                id="budget-slider"
                type="range"
                step={1}
                value={budget || 0}
                min={minBudget}
                max={maxBudget}
                onChange={this.onChangeBudget}
              />
              {this.renderTicks(
                maxBudget,
                minBudget,
                budgetDefault,
                budget500,
                budget1000,
                budget1500
              )}

              <CreateTipp
                tippWidth={budgetSliderWidth}
                left={`${Math.max((budget * 100) / maxBudget - 9.7, 0)}%`}
                title={reichweiteDescription}
                onChangeJobCategory={this.onChangeJobCategory.bind(this)}
                jobCategoryId={jobCategoryId}
                minClicks={this.props.calcMinClicks(budget || 0, selectedChannels)}
                city_size={city_size}
                locations={location}
              />
            </div>
            <ReactTooltip className="campaign_create__tooltip" />
          </div>
        </div>
        {this?.props?.children}
      </div>
    );
  }
}
export default withRouter(withTranslation()(AssistantBudgetCalculator));
